import cn from 'classnames'
// eslint-disable-next-line no-restricted-imports
import '@mc/certificates-design-system/src/styles/globals.scss'
// eslint-disable-next-line no-restricted-imports
import '@mc/certificates-design-system/src/styles/typography.css'

interface LayoutProps {
  children: React.ReactNode | React.ReactNode[]
  theme?: 'light' | 'dark'
  background?: 'solid' | 'transparent'
  backgroundColor?: string
}

export const Layout = ({
  children,
  theme = 'light',
  background = 'solid',
  backgroundColor = 'var(--c-beige-400)',
}: LayoutProps) => (
  <>
    {theme === 'light' && background === 'solid' && (
      <style jsx global>{`
        body {
          background: ${backgroundColor};
        }
      `}</style>
    )}

    <div className='certificates-theme'>
      <div
        className={cn({
          'mc-theme-light': theme === 'light',
          'mc-theme-dark': theme === 'dark',
        })}
      >
        {children}
      </div>
    </div>
  </>
)
